export const CarViewEnum = Object.freeze({
    list: 'list',
    cards: 'cards',
});